var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-achievement-count"},[_c('div',{staticClass:"u-stat"},_vm._l((_vm.countDict),function(text,key){return _c('span',{key:key},[_c('em',[_vm._v(_vm._s(text))]),_c('b',[_vm._v(_vm._s(_vm.count[key]))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }